var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _rect, _rect2, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJetfirsatBannerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 49,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.45 25.983v22.47h31.364V44.04",
    stroke: "#000",
    strokeWidth: 0.747,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.998 22h30v26h-30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.51 41.843v-19.21",
    stroke: "#000",
    strokeWidth: 0.747,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.787 13.444H8.386a.587.587 0 00-.536.329l-3.468 7.331a.531.531 0 00.042.53.594.594 0 00.492.255h33.66a.595.595 0 00.493-.254.533.533 0 00.043-.53l-2.413-7.332a.589.589 0 00-.535-.329h-6.609",
    fill: "#E5E5E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.409 22.632h13.276v-.817H5.589c-.46 0-.711-.347-.558-.772l2.172-6.027c.186-.447.62-.749 1.113-.771h16.22a.414.414 0 00.418-.41.414.414 0 00-.417-.409H7.725a1.266 1.266 0 00-1.113.77l-2.76 7.664c-.153.425.097.772.557.772zm35.163 0c.443 0 .687-.347.54-.772l-2.645-7.658a1.222 1.222 0 00-1.072-.776h-6.411a.406.406 0 00-.403.41c0 .225.18.408.403.408h5.838a1.22 1.22 0 011.073.773l2.079 6.024c.147.425-.096.772-.54.772l-7.532.047v.818l8.67-.046z",
    fill: "#000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.686 48.452h13.217V22.24l-5.05-5.341a1.983 1.983 0 00-2.85-.033l-5.317 5.374v26.212z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.747
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.895 44.573h4.708l1.437 3.879h-7.327l1.182-3.88z",
    fill: "#CCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.105 44.573v-5.647c0-.346.326-.626.728-.626h2.92c.402 0 .728.28.728.626v5.647",
    fill: "#F3FBFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.909 44.573h-.855v-5.647c0-.097-.124-.205-.3-.205h-2.92c-.178 0-.301.108-.301.205v5.647h-.855v-5.647c0-.577.518-1.048 1.155-1.048h2.92c.637 0 1.156.47 1.156 1.048v5.647zm1.35 3.879h-.856v-1.096c0-.2-.205-.364-.458-.364h-5.303c-.257 0-.459.164-.459.364v1.096h-.855v-1.096c0-.665.59-1.207 1.314-1.207h5.303c.724 0 1.314.542 1.314 1.207v1.096z",
    fill: "#000"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M27.39 46.23h-.855v-1.095c0-.209-.127-.364-.24-.364h-3.999c-.113 0-.24.155-.24.364v1.095h-.855v-1.095c0-.666.491-1.207 1.095-1.207h3.996c.604 0 1.095.54 1.095 1.207l.003 1.095z",
    fill: "#000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.641,
    y: 20.696,
    width: 3.304,
    height: 3.304,
    rx: 0.707,
    fill: "#D9F3FE",
    stroke: "#000",
    strokeWidth: 0.746
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.641,
    y: 28.626,
    width: 3.304,
    height: 3.304,
    rx: 0.707,
    fill: "#D9F3FE",
    stroke: "#000",
    strokeWidth: 0.746
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M57.997 38.352v-5.43H36.85v15.86h21.147v-5.26",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.997 48.782H36.85V32.261h21.147v7.402a.372.372 0 11-.742 0v-6.659H37.592V48.04h19.663v-4.49a.372.372 0 11.742 0v5.233z",
    fill: "#000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.782 26.643H37.705a.41.41 0 00-.374.232l-2.427 5.163a.376.376 0 00.029.374c.075.112.205.18.344.18H59.57a.414.414 0 00.344-.18.377.377 0 00.03-.374l-2.427-5.163a.412.412 0 00-.374-.232h-4.625",
    fill: "#CCC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.642 32.922H35.03a.85.85 0 01-.627-.257.708.708 0 01-.124-.8l2.46-5.11a.807.807 0 01.73-.442h10.865c.212 0 .385.161.385.36 0 .199-.172.36-.385.36H37.468a.03.03 0 00-.028.016l-2.459 5.11a.023.023 0 000 .027.027.027 0 00.025.013h24.618a.03.03 0 00.025-.013.025.025 0 000-.027l-2.46-5.11a.03.03 0 00-.027-.016h-4.298c-.213 0-.386-.161-.386-.36 0-.199.173-.36.386-.36h4.3c.316 0 .602.173.731.441l2.46 5.11a.707.707 0 01-.127.798.85.85 0 01-.626.26h1.04z",
    fill: "#000"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.426 46.798v-7.135c0-.437.394-.794.88-.794h3.528c.485 0 .879.354.879.794V46.8",
    fill: "#F3FBFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.426 46.798v-7.135c0-.437.394-.794.88-.794h3.528c.485 0 .879.354.879.794V46.8",
    stroke: "#000",
    strokeWidth: 0.746
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.103 48.386v-.987a.997.997 0 01.995-.996h5.943c.548 0 .993.446.993.996v.979l-7.93.008z",
    fill: "#E5E5E5",
    stroke: "#000",
    strokeWidth: 0.746
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M66.292 40.905c-.075-1.108-.586-1.461-.787-1.819-.287-.507.704-2.7-1.68-2.7-2.383 0-1.436 2.198-1.679 2.7-.206.427-.794.79-.794 2.044 0 1.917 1.563 2.485 2.474 2.485.653 0 1.64-.635 2.15-1.457",
    fill: "#BCE2B5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M66.292 40.905c-.075-1.108-.586-1.461-.787-1.819-.287-.507.704-2.7-1.68-2.7-2.383 0-1.436 2.198-1.679 2.7-.206.427-.794.79-.794 2.044 0 1.917 1.563 2.485 2.474 2.485.653 0 1.64-.635 2.15-1.457",
    stroke: "#1A1A1A",
    strokeWidth: 0.747,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M63.84 48.266v-4.649 4.65z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M63.84 48.266v-4.649",
    stroke: "#1A1A1A",
    strokeWidth: 0.747,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M69.837 42.732c.502 1.797 1.967 2.083 2.795 2.095 1.036.017 3.3-.362 3.181-3.88-.039-1.167-.262-2.345-.75-3.42-.32-.703-.764-1.433-1.424-1.907-.49-.353-1.084-.351-1.595-.032-.612.381-1.03 1.008-1.365 1.606-.562 1.005-.863 2.13-.972 3.257a9.411 9.411 0 00-.034.445c-.01.186-.01.362-.01.532",
    fill: "#EEF8EC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M69.837 42.732c.502 1.797 1.967 2.083 2.795 2.095 1.036.017 3.3-.362 3.181-3.88-.039-1.167-.262-2.345-.75-3.42-.32-.703-.764-1.433-1.424-1.907-.49-.353-1.084-.351-1.595-.032-.612.381-1.03 1.008-1.365 1.606-.562 1.005-.863 2.13-.972 3.257a9.411 9.411 0 00-.034.445c-.01.186-.01.362-.01.532m3.089 6.942v-3.438",
    stroke: "#1A1A1A",
    strokeWidth: 0.747,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.515 2.276L69.252.54l7.182.07-4.57 6.32 5.3-.047-9.823 11.5 2.073-8.668-4.146-.253 2.012-4.397",
    fill: "#89CD7D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M68.515 2.276L69.252.54l7.182.07-4.57 6.32 5.3-.047-9.823 11.5 2.073-8.668-4.146-.253 2.012-4.397",
    stroke: "#000",
    strokeWidth: 0.747,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.605 21.798l.328-.772 3.192.031-2.03 2.81 2.354-.022-4.365 5.112.921-3.853-1.843-.112.895-1.955",
    fill: "#BCE2B5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M78.605 21.798l.328-.772 3.192.031-2.03 2.81 2.354-.022-4.365 5.112.921-3.853-1.843-.112.895-1.955",
    stroke: "#000",
    strokeWidth: 0.529,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.469 12.936l.23-.5 2.394.022-1.523 2.107 1.766-.016-3.274 3.834.691-2.89-1.382-.084.671-1.466",
    fill: "#ACECA1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M54.469 12.936l.23-.5 2.394.022-1.523 2.107 1.766-.016-3.274 3.834.691-2.89-1.382-.084.671-1.466",
    stroke: "#000",
    strokeWidth: 0.463,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1.164 48.452h78.644",
    stroke: "#000",
    strokeWidth: 0.747,
    strokeLinecap: "round"
  })));
}
export default SvgJetfirsatBannerIcon;